var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.31 4.662-1.19 1.19-2.975-2.98 1.19-1.19a.657.657 0 0 1 .907 0l2.069 2.073c.25.25.25.657 0 .907m-9.944 9.955-2.975-2.98 7.692-7.702 2.976 2.979zm-3.662-1.543 2.226 2.23-3.1.874zM17.372 2.693 15.304.62c-.404-.404-1.863-1.168-3.027 0L1.797 11.11a.7.7 0 0 0-.191.327L.026 17.06c-.073.26.004.54.191.735.191.194.573.227.735.19l5.62-1.583a.7.7 0 0 0 .327-.19L17.372 5.723a2.15 2.15 0 0 0 0-3.031"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgPencil;